import { render, staticRenderFns } from "./AdminPostEdit.vue?vue&type=template&id=496b7022"
import script from "./AdminPostEdit.vue?vue&type=script&lang=js"
export * from "./AdminPostEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports